import type { CalendarSurfaceItemContentProps } from './CalendarSurfaceItem.types';
import { createSubjectGridStyleWithoutJoinButton } from '../../utils/createSubjectGridStyle';
import CalendarSurfaceItemClipping from '../CalendarSurfaceItemClipping';
import { renderCharmWrapper, renderIconWrapper } from '../CalendarSurfaceItemComponentRenderer';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import {
    getCalendarEventItemSubjectText,
    getCalendarEventItemLocationText,
} from 'owa-calendar-event-attributes';

import classNames from 'classnames';
import styles from '../CalendarSurfaceItem.scss';

/**
 * The Component for a Calendar Surface item 20 minutes or under
 */
export default observer(function CalendarSurfaceItemUnder20(
    props: CalendarSurfaceItemContentProps
) {
    const wrapperRef = React.useRef<HTMLDivElement>();
    const { item, colorScheme, charmId, allowEmptySubject } = props;
    const subject = getCalendarEventItemSubjectText(item, allowEmptySubject);
    const location = getCalendarEventItemLocationText(item);
    const organizer = item.Organizer && item.Organizer.Mailbox.Name;

    const LocationEntry = (
        <>
            {location && (
                <span
                    className={classNames(
                        styles.locationWrapper,
                        styles.itemElementContentUnder30
                    )}>
                    {location}
                </span>
            )}
            {item.IsMeeting && organizer && (
                <span
                    className={classNames(
                        styles.locationWrapper,
                        styles.itemElementContentUnder30
                    )}>
                    {organizer}
                </span>
            )}
        </>
    );

    const realSubject = subject ? subject : location;
    const wordBreakStyle =
        realSubject.indexOf(' ') > 0 ? styles.wordBreakNormalStyle : styles.wordBreakAllStyle;

    return (
        <>
            <div
                className={classNames(
                    styles.itemContent,
                    styles.calendarItemClippingLineUnder20,
                    styles.singleLineItemUnder20
                )}
                ref={wrapperRef}>
                <div
                    className={classNames(
                        styles.headerContainerUnder20,
                        styles.headerContainerGridGap
                    )}
                    style={createSubjectGridStyleWithoutJoinButton()}>
                    <div className={styles.headerSubjectWrapper}>
                        <h2
                            className={classNames(
                                styles.itemSubjectUnder20,
                                styles.truncatedSubjectUnder20,
                                wordBreakStyle
                            )}>
                            <CalendarSurfaceItemClipping
                                lineHeight={14}
                                lines={1}
                                whiteSpace={'normal'}>
                                {renderCharmWrapper(
                                    item,
                                    colorScheme,
                                    charmId,
                                    null /* styles */,
                                    true /* isShortest */
                                )}
                                <span className={styles.headerMarginSingleLine}>{realSubject}</span>
                                {LocationEntry}
                            </CalendarSurfaceItemClipping>
                        </h2>
                    </div>
                </div>
            </div>
            {renderIconWrapper(
                item,
                true /* isShorter */,
                null /* itemState */,
                null /* styles */,
                true /* isShortest */
            )}
        </>
    );
});
